import { Component } from '@angular/core';
import {TableComponent} from "../../../shared/components/table/table.component";
import {CancelEventComponent} from "../../service/event/cancel-event/cancel-event.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {GeneralService} from "../../../core/services/general.service";
import {AddCapacityComponent} from "./add-capacity/add-capacity.component";
import {NewComponent} from "./new/new.component";

@Component({
  selector: 'app-category',
  standalone: true,
  imports: [
    TableComponent
  ],
  templateUrl: './category.component.html',
  styleUrl: './category.component.scss'
})
export class CategoryComponent {
  configurationTable: any = {
    "columns": [
      {
        "id": "category_vehicle.id",
        "title": "Clave",
        "type": "text",
        "placeholder": "",
        "required": false,
        "hide": true
      },
      {
        "id": "category_vehicle.description",
        "title": "Descripción",
        "type": "text",
        "placeholder": "Ingresa una descripción",
        "required": true
      },
      {
        "id": "category_vehicle.image",
        "title": "Imágen",
        "type": "images",
        "placeholder": "",
        "required": true
      },
      {
        "id": "category_vehicle.comfort",
        "title": "Comodidad",
        "type": "text",
        "placeholder": "Detalle de comodidad (Separados por ',')",
        "required": false
      },
      {
        "id": "category_vehicle.security",
        "title": "Seguridad",
        "type": "text",
        "placeholder": "Detalle de seguridad (Separados por ',')",
        "required": false
      },
      {
        "id": "category_vehicle.capacity",
        "title": "Capacidad",
        "type": "text",
        "placeholder": "Detalle de capacidad (Separados por ',')",
        "required": false
      },
      {
        "id": "category_vehicle.vehicles_description",
        "title": "Vehículos",
        "type": "text",
        "placeholder": "Detalle de vehículos",
        "required": false
      },
      /*{
        "id": "capacity",
        "title": "Capacidad",
        "condition": "GROUP_CONCAT(DISTINCT configurableLists.configurableListsCode ORDER BY configurableLists.configurableListsCode ASC)",
        "isHaving": true,
        "onlyTable": true
      },
      {
        "id": "",
        "title": "Capacidad",
        "onlyForm": true,
        "type": "multiselect",
        "placeholder": "Seleccione",
        "serviceConfig": {
          "table": "confList",
          "idColumn": "idconfigurableLists",
          "valueColumn": "configurableListsCode",
          "conditionColumn":"configurableListsField",
          "conditionValue":"Categoría capacidad"
        },
        "required": false
      },*/
      {
        "btnName": "Opciones",
        "actions": [
          {
            "btnName": "Editar evento",
            "textConfirmation": "",
            "action": {
              "type": "emmit",
              "fn": this.editCategory.bind(this)
            },
            "type":{
              "type":"btn-icon",
              "class": 'btn-pill btn-outline-success border border-success',
              "icons": 'edit'
            }
          },
          /*{
            "btnName": "Editar",
            "textConfirmation": "¿Desea desactivar al usuario seleccionado?",
            "action": {
              "type": "update"
            }
          },*/
          {
            "btnName": "Eliminar",
            "textConfirmation": "¿Desea eliminar el usuario seleccionado?",
            "action": {
              "type": "delete"
            }
          }
        ]
      }
    ],
    "config": "categoryVehicle",
    "sortColumn": "category_vehicle.description",
    "sortDirection": "ASC",
    "title": "Categoría",
    "filterPrincipal": [
    ],
    "filters":[]
  };

  constructor(public modal : NgbModal, private generalService:GeneralService) {

  }

  editCategory(row:any){
    let modal = this.modal.open(NewComponent, { centered: true, size:'xl' });
    modal.componentInstance.data = row;
    modal.componentInstance.confirmAction = (data: any) => {
      //ToDo;
    };
  }
}
